import { TenantRoles } from './../../../../constants';
import { useTranslation } from 'react-i18next';
import {
  GridColumns,
  GridColDef,
  GridRowParams,
  GridActionsCellItem
} from '@mui/x-data-grid-premium';
import DeleteIcon from '@mui/icons-material/Delete';
import { IUser } from 'interfaces';

export function UserColumns(
  warehouse_codes: string[],
  supplier_codes: string[],
  disableUser?: (user: IUser) => void
): GridColumns | GridColDef[] {
  const { t } = useTranslation('');

  const columns: GridColumns | GridColDef[] = [];
  ['username', 'first_name', 'last_name', 'email'].forEach((field) => {
    columns.push({
      field: field,
      width: 250,
      headerName: t(`entities.user.${field}`),
      editable: true
    });
  });

  columns.push({
    field: 'groups',
    width: 250,
    editable: true,
    headerName: 'Ruolo',
    type: 'singleSelect',
    valueOptions: TenantRoles
  });

  columns.push({
    field: 'warehouse',
    width: 250,
    valueGetter: (params) => params.row?.settings?.warehouse ?? '',
    type: 'singleSelect',
    valueOptions: [
      { value: '', label: t('global.none', 'Nessuno') },
      ...warehouse_codes.map((code) => ({ value: code, label: code }))
    ],
    headerName: t(`global.warehouse`),
    editable: true
  });

  columns.push({
    field: 'supplier',
    width: 250,
    valueGetter: (params) => params.row?.supplier,
    type: 'singleSelect',
    valueOptions: supplier_codes,
    headerName: t(`global.supplier`),
    editable: true
  });

  columns.push({
    field: '',
    width: 100,
    type: 'actions',
    getActions: (params: GridRowParams) => {
      return [
        <GridActionsCellItem
          key={1}
          label={t('actions.delete')}
          icon={<DeleteIcon />}
          onClick={() => disableUser(params.row as IUser)}
        />
      ];
    }
  });

  return columns;
}
